import React, { useEffect, useState } from "react";
import {
  clientSettingsActions,
  clientActions,
  matrixFieldsActions,
  useSelector,
  resourcesActions,
} from "inbooma-api";
import { Biscuit, getAllUrlParams, Notification } from "../../../../utils";
import t from "../../../helpers/t";
import { Box, Tab, Tabs, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import GeneralSettings from "./GeneralSettings";
import BookingSettings from "./BookingSettings";
import UserSettings from "./UserSettings";
import { in_array, isValidUrl } from "../../../../utils/Helper";
import { NodeHtmlMarkdown, NodeHtmlMarkdownOptions } from "node-html-markdown";
import ChangeMatrixField from "./ChangeMatrixField";
import Tools from "./Tools";

const SettingsView = (props) => {
  const { dispatch, params, returnPath } = props;
  let language = Biscuit.get("user.lang").replace("-", "_");
  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const allUrlParams = getAllUrlParams(window.location.href);
  const [initialized, setInitialized] = useState(false);
  const _settings = useSelector((state) => state.client_settings_data.getClientSettings);
  const _setting = useSelector((state) => state.client_settings_data.editClientSetting);
  const _client = useSelector((state) => state.client_data.client);
  const _editClient = useSelector((state) => state.client_data.editClient);
  const _matrix_fields = useSelector((state) => state.matrix_fields_data.matrixFields);
  const [setting, setSetting] = useState(null);
  const [client, setClient] = useState(null);
  const [matrixFields, setMatrixFields] = useState(null);
  const [tempMatrixFields, setTempMatrixFields] = useState(null);
  const [matrixField, setMatrixField] = useState(null);
  const [matrixFieldFunction, setMatrixFieldFunction] = useState(null);
  const [settingPending, setSettingPending] = useState(false);
  const [clientPending, setClientPending] = useState(false);
  const [settingsPending, setSettingsPending] = useState(false);
  const [matrixFieldsPending, setMatrixFieldsPending] = useState(false);
  const [showChange, setShowChange] = useState(false);
  const [onLoad, setOnLoad] = useState(true);
  let indTemp = null,
    ind = 0;
  const [changed, setChanged] = useState({
    client_settings: false,
    clients: false,
    matrix_fields: false,
  });
  const [notification, setNotification] = useState({
    message: "",
    show: false,
  });
  const [value, setValue] = useState(
    typeof allUrlParams.panel !== "undefined" ? Number(allUrlParams.panel) : 0,
  );

  const _showPopUp = (ev, name) => {
    let output =
      `
          <html>
            <head>
                <link href="https://fonts.googleapis.com/css?family=Open+Sans:400,600" rel="stylesheet">
                <title>` +
      t("info", null, "capital") +
      `</title>
                <style type="text/css">
                    body { font-family: "Open Sans",Helvetica,Arial,sans-serif; }
                    hode, html, table, thead { width: 100%; }
                    h4 { font-size: 18px; }
                    .printSpacer { height:100px; }
                </style>
                </head>
            <div>` +
      t(name + "_info") +
      `
            </body>
            </html>`;
    let rV = -1; // Return value assumes failure.

    if (navigator.appName == "Microsoft Internet Explorer" || navigator.appName == "Netscape") {
      var uA = navigator.userAgent;
      var rE = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");

      if (rE.exec(uA) != null) {
        rV = parseFloat(RegExp.$1);
      } else if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        rV = 11;
      }
    }

    const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    const newWindow = window.open("", "", "height=700,width=674");

    newWindow.document.body.innerHTML = "";
    newWindow.document.body.innerHTML = output;
    if (rV >= 10 || isChrome) {
      newWindow.focus(); // necessary for IE >= 10*
    } else {
      // e.g. Firefox
      setTimeout(() => {
        newWindow.opener.focus();
      }, 0);
    }
    return true;
  };
  const checkChange = () => {
    let somethingHasChanged = false;
    Object.values(changed).map(function (value, key) {
      if (value) {
        somethingHasChanged = true;
        return;
      }
    });
    return somethingHasChanged;
  };

  const showChangeView = (item, setFunction, holder, type) => {
    setMatrixField(item);
    setMatrixFieldFunction(setFunction);
    setTempMatrixFields(holder);
    let clone1 = tempMatrixFields;
    if (clone1 !== null) {
      clone1.map(function (it, index) {
        if (it.id === matrixField.id) {
          indTemp = index;
          return;
        }
      });
    }
    setShowChange(true);
  };

  useEffect(() => {
    if (!settingsPending || _settings.success === "") {
      return;
    }
    if (_settings.success === true) {
      setSetting(_settings.data[0]);
    } else {
      console.log("Failed fetching setting!");
    }
    setSettingsPending(false);
    if (!clientPending && !matrixFieldsPending) {
      setInitialized(true);
    }
  }, [_settings]);

  useEffect(() => {
    if (!settingPending || _setting.success === "") {
      return;
    }
    if (_setting.success === true) {
      let clone = {};
      Object.assign(clone, changed);
      clone.client_settings = false;
      setChanged(clone);
      showNotification("success", _setting.data.id, null, "settings");
    } else {
      showNotification("warning", _setting.data.id, _setting.data.message, "settings");
      console.log("Failed edit setting!");
    }
    setSettingPending(false);
  }, [_setting]);

  useEffect(() => {
    if (!clientPending || _client.success === "") {
      return;
    }
    if (_client.success === true) {
      let clone = {};
      Object.assign(clone, changed);
      clone.clients = false;
      setChanged(clone);
      showNotification("success", _client.data.id);
    } else {
      showNotification("warning", _client.data.id);
      console.log("Failed edit client!");
    }
    setClientPending(false);
  }, [_editClient]);

  useEffect(() => {
    if (!clientPending || _client.success === "") {
      return;
    }
    if (_client.success === true) {
      setClient(_client.data);
    } else {
      console.log("Failed load client!");
    }
    setClientPending(false);
    if (!settingsPending && !matrixFieldsPending) {
      setInitialized(true);
    }
  }, [_client]);

  useEffect(() => {
    if (!matrixFieldsPending || _matrix_fields.success === "") {
      return;
    }
    if (_matrix_fields.success === true) {
      setMatrixFields(_matrix_fields.data);
    } else {
      console.log("Failed fetch matrix fields!");
    }
    setMatrixFieldsPending(false);
    if (!settingsPending && !clientPending) {
      setInitialized(true);
    }
  }, [_matrix_fields]);

  const initialize = () => {
    if (settingPending || settingsPending || clientPending || matrixFieldsPending) {
      return;
    }
    dispatch(
      clientSettingsActions.getClientSettings({
        token: Biscuit.get("token"),
        suffix: "",
        filter: {
          client_id: Biscuit.get("user.client_id"),
        },
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setSettingsPending(true);
    dispatch(
      clientActions.getClient({
        token: Biscuit.get("token"),
        suffix: "",
        client_id: Biscuit.get("user.client_id"),
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setClientPending(true);
    dispatch(
      matrixFieldsActions.getMatrixFields({
        filter: {
          client_id: Biscuit.get("user.client_id"),
        },
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setMatrixFieldsPending(true);
  };

  if (!initialized) {
    initialize();
  }

  const showNotification = (msgType, itemId, errorMsg = "", type = "client") => {
    if (msgType === "success") {
      new Notification({
        message: t("saved_${a}", { a: t(type) }, "capital") + " #" + itemId,
        duration: 5000,
        type: "success",
        closeable: true,
        icon: "fi fi-check",
      });
    } else if (msgType === "warning") {
      new Notification({
        message: errorMsg,
        duration: 5000,
        type: "warning",
        closeable: true,
        icon: "fi fi-x",
      });
    }
  };
  const fieldsToDeleteByPatch = [
    "created",
    "modified",
    "deleted",
    "created_by",
    "modified_by",
    "client_settings",
    "client_templates",
    "locations",
    "pricetariffs",
    "resourcetypes",
    "facilities",
    "client_specific_events",
  ];
  const checkBoxFields = [
    "cancel_requested_orders",
    "send_reminder_mail_for_offers",
    "cancelNoCheckin",
    "show_usage_type",
    "pre_booking_possible",
    "verify_email",
    "verify_postal",
    "uses_code_for_verification",
    "verify_mobile_number",
    "is_public",
    "use_memberships",
    "active",
    "cancelPossible",
    "end_changeable",
    "cancelAfterCheckinPossible",
    "cancelBeforeCheckinPossible",
    "autoCheckout",
    "withAutoCheckin",
    "withAutoCheckinCheckOut",
    "sharedLocationsForResources",
    "withTicketOnMessage",
  ];
  const timeFields = [
    "cancel_requested_orders_time",
    "reminder_time_for_offers",
    "cancelCheckinTime",
    "reservationBuffer",
    "maxBookingTime",
    "tokenDuration",
    "timeSendMailBeforeEnd",
  ];
  const inputFields = [
    "countOfBookingsAtSameTime",
    "countOfBookings",
    "primaryColor",
    "secondaryColor",
    "font",
    "fontSize",
    "email",
    "organization",
    "display_name",
    "city",
    "zip",
    "street",
    "currency",
    "number",
    "country",
    "ust_id",
    "phone",
    "url",
    "product",
  ];
  const textFields = ["agb", "help"];
  const clientSettingsFields = [
    "cancel_requested_orders",
    "send_reminder_mail_for_offers",
    "cancelNoCheckin",
    "show_usage_type",
    "pre_booking_possible",
    "cancel_requested_orders_time",
    "reminder_time_for_offers",
    "cancelCheckinTime",
    "reservationBuffer",
    "maxBookingTime",
    "countOfBookingsAtSameTime",
    "countOfBookings",
    "primaryColor",
    "secondaryColor",
    "font",
    "fontSize",
    "verify_email",
    "verify_postal",
    "uses_code_for_verification",
    "verify_mobile_number",
    "use_memberships",
    "display_name",
    "product",
    "cancelPossible",
    "end_changeable",
    "cancelAfterCheckinPossible",
    "cancelBeforeCheckinPossible",
    "autoCheckout",
    "withAutoCheckin",
    "withAutoCheckinCheckOut",
    "sharedLocationsForResources",
    "withTicketOnMessage",
    "tokenDuration",
    "timeSendMailBeforeEnd",
  ];
  const clientFields = [
    "agb",
    "help",
    "email",
    "organization",
    "city",
    "zip",
    "street",
    "currency",
    "number",
    "country",
    "is_public",
    "ust_id",
    "phone",
    "url",
    "payment_methods",
    "active",
  ];
  const select2Fields = ["payment_methods"];
  const fieldsToValidate = {
    product: {
      "12drivebikesharing": "12DRIVE Bikesharing",
      "12drive bikesharing": "12DRIVE Bikesharing",
      mieton: "MietOn",
      bewegungumdenken: "BewegungUmdenken",
      "bewegung umdenken": "BewegungUmdenken",
    },
  };
  const onChange = (e, name) => {
    let clone = {},
      clone2 = {},
      clone3 = {};
    Object.assign(clone, changed);
    if (in_array(name, clientSettingsFields)) {
      clone.client_settings = true;
    }
    let now = "setting";
    if (in_array(name, clientFields)) {
      if (!onLoad || !in_array(name, textFields)) {
        clone.clients = true;
        now = "client";
      } else {
        setOnLoad(false);
      }
    }
    setChanged(clone);
    Object.assign(clone2, setting);
    Object.assign(clone3, client);
    if (in_array(name, checkBoxFields)) {
      if (now === "client") {
        clone3[name] = e.currentTarget.checked;
      } else {
        if (name === "autoCheckout") {
          Biscuit.set("client.autoCheckout", e.currentTarget.checked);
        }
        clone2[name] = e.currentTarget.checked;
      }
    }
    if (in_array(name, timeFields)) {
      clone2[name] = e;
    }
    if (in_array(name, inputFields)) {
      let val = e.currentTarget.value;
      if (
        typeof fieldsToValidate[name] !== "undefined" &&
        typeof fieldsToValidate[name][val.toLowerCase()] !== "undefined"
      ) {
        val = fieldsToValidate[name][val.toLowerCase()];
      }
      if (now === "client") {
        clone3[name] = val;
      } else {
        clone2[name] = val;
      }
    }
    if (in_array(name, textFields)) {
      if (e.replace(/<(.|\n)*?>/g, "").trim().length === 0) {
        clone3[name] = null;
      } else {
        if (isValidUrl(e)) {
          clone3[name] = e;
        } else {
          clone3[name] = NodeHtmlMarkdown.translate(e);
        }
      }
    }
    if (in_array(name, select2Fields)) {
      let fields = [];
      e.result.map((field) => {
        fields.push(field.id);
      });
      if (now === "client") {
        clone3[name] = fields.length > 0 ? fields.join(",") : null;
      } else {
        clone2[name] = fields.length > 0 ? fields.join(",") : null;
      }
    }
    setSetting(clone2);
    setClient(clone3);
  };

  const closeNotification = () => {
    setNotification({
      ...notification,
      show: false,
    });
  };

  const onSubmit = () => {
    if (changed.client_settings) {
      const se = {};
      Object.assign(se, setting);
      fieldsToDeleteByPatch.map((field) => {
        if (typeof se[field] !== "undefined") {
          delete se[field];
        }
      });
      dispatch(
        clientSettingsActions.editClientSetting({
          id: se.id,
          token: Biscuit.get("token"),
          data: se,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setSettingPending(true);
    }
    if (changed.clients) {
      const cl = {};
      Object.assign(cl, client);
      fieldsToDeleteByPatch.map((field) => {
        if (typeof cl[field] !== "undefined") {
          delete cl[field];
        }
      });
      dispatch(
        clientActions.editClient({
          id: cl.id,
          token: Biscuit.get("token"),
          body: cl,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setClientPending(true);
    }
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const close = () => {
    let somethingHasChanged = checkChange();
    let bestaetigung;
    if (somethingHasChanged) {
      bestaetigung = window.confirm(
        t("Something has changed, are you sure that you want to close without save?"),
      );
    } else {
      bestaetigung = true;
    }
    if (bestaetigung) {
      let returnUrl = typeof returnPath !== "undefined" ? returnPath : "#";
      dispatch(matrixFieldsActions.getMatrixFieldsResetData());
      window.location.replace(returnUrl);
    }
  };
  const abortButtonRef = React.createRef();

  return (
    <>
      <div className="js-off-canvas-overlay is-overlay-fixed is-visible"></div>
      {notification.show && (
        <>
          <Notification message={notification.message} close={closeNotification}></Notification>
        </>
      )}
      {!showChange && (
        <>
          <div
            className="off-canvas position-right is-transition-overlap is-open"
            id="inb-off-canvas-settings"
            data-off-canvas="85mrb3-off-canvas"
            aria-hidden="false"
          >
            <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
              <h1 className="inb-page-title">{t("edit_${a}", { a: t("settings") })}</h1>
              <div className="off-canvas__actions column">
                <button
                  type="submit"
                  className={
                    "button medium beautify beautify-" +
                    Biscuit.get("user.client_id") +
                    " button-submit round"
                  }
                  title={t("save")}
                  onClick={onSubmit}
                >
                  {!settingPending && !clientPending && (
                    <>
                      <i className="fi fi-check"> </i>
                      <span>{t("save")}</span>
                    </>
                  )}
                  {settingPending ||
                    (clientPending && (
                      <span>
                        <img
                          alt="RollingLoader"
                          className="rollingLoader"
                          src={"assets/img/rolling_loader.svg"}
                        />
                        {t("save")}
                      </span>
                    ))}
                </button>
                <a href="#">
                  <button
                    ref={abortButtonRef}
                    type="button"
                    id="inb-tasksform-abort-button"
                    className="button hollow secondary right button-abort round"
                    title={t("close_window")}
                    onClick={() => close()}
                  >
                    <i className="fi fi-x"> </i>
                  </button>
                </a>
              </div>
            </header>
            {initialized && (
              <p
                className="off-canvas__subtitle off-canvas__header-region"
                style={{ paddingLeft: "30px" }}
              >
                Client: {client.organization + " (" + client.id + ")"}, Aktuelle Kontingentanzahl
                (Stand heute): {setting.countContingents}
              </p>
            )}
            {initialized && (
              <>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs value={value} onChange={handleChange} aria-label="setting tabs">
                    <Tab label={t("general")} {...a11yProps(0)} />
                    <Tab label={t("bookings")} {...a11yProps(1)} />
                    <Tab label={t("users")} {...a11yProps(2)} />
                    <Tab label={t("tools")} {...a11yProps(3)} />
                  </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                  <GeneralSettings
                    setting={setting}
                    client={client}
                    onChange={onChange}
                    _showPopUp={_showPopUp}
                  />
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <BookingSettings setting={setting} onChange={onChange} _showPopUp={_showPopUp} />
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <UserSettings
                    setting={setting}
                    matrixFields={matrixFields}
                    setMatrixFields={setMatrixFields}
                    dispatch={dispatch}
                    onChange={onChange}
                    showChangeView={showChangeView}
                    _showPopUp={_showPopUp}
                    subPanel={
                      typeof allUrlParams.subpanel !== "undefined" ? allUrlParams.subpanel : 0
                    }
                  />
                </TabPanel>
                <TabPanel value={value} index={3}>
                  <Tools dispatch={dispatch} />
                </TabPanel>
              </>
            )}
            {!initialized && (
              <>
                <div style={{ maxHeight: "40px", width: "100%", textAlign: "center" }}>
                  <img
                    className="rollingLoader colorize-black"
                    src="assets/img/rolling_loader.svg"
                  />
                </div>
              </>
            )}
          </div>
        </>
      )}
      {showChange && (
        <ChangeMatrixField
          matrixField={matrixField}
          index={ind}
          matrixFields={matrixFields}
          setMatrixFields={setMatrixFields}
          setMatrixField={setMatrixFieldFunction}
          tempMatrixFields={tempMatrixFields}
          tempIndex={indTemp}
          setShowChange={setShowChange}
          dispatch={dispatch}
        />
      )}
    </>
  );
};

export default SettingsView;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
